import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../redux';
import utils from '../../utils';
import './group-switcher.css';

function CustomerGroupSpan() {
  const context = useSelector((state: RootState) => state.api.context);
  const data = useSelector((state: RootState) => state.api.data);
  let customerGroup;

  if (context) {
    customerGroup = utils.findItemByUuid(data, context.customer_group_uuid);
  }

  return (
    <span
      className="group-name item-name-text-ellipsis"
      data-testid="customer-group"
    >
      {customerGroup?.name ?? 'Customer group'}
    </span>
  );
}

export default CustomerGroupSpan;
